import type { WNewsletterTranslations } from "./pl";

export const de: WNewsletterTranslations = {
  noConfig: "Keine Konfigurationsdaten für das Newsletter-Fenster.",
  noCatalog:
    "Dem Newsletter-Fenster ist keine Anmeldeseite zugewiesen. Konfiguriere den verknüpften Katalog im Administrationsbereich.",

  info: "Erhalte Informationen von uns!",
  typeEmail: "E-Mail-Adresse eingeben",
  save: "Anmelden",

  closeLabel: "Schließen",

  validation: {
    requiredEmail: "Bitte gib deine E-Mail-Adresse ein.",
    invalidEmail: "Ungültige E-Mail-Adresse.",
    requiredConsent:
      "Die Einwilligung zur Verarbeitung personenbezogener Daten ist erforderlich.",
  },
};
